module.exports = __webpack_public_path__ + "assets/sr.2df932b9.svg";